import { styled } from '@mui/material';

export const TabsWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
}));

export const TableControlsWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    flexDirection: isMobile ? 'row' : 'column',
    alignItems: isMobile ? 'center' : 'flex-end',
    margin: 0,
    gap: '6px',
  },
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    gap: '4px',
    '& .MuiButton-root': {
      padding: '0 8px',
      fontSize: '0.75rem',
    },
    '& .MuiButton-startIcon': {
      marginRight: '4px',
    },
  },
}));
